import React from 'react';
import { Chip } from '@mui/material';
import { X } from '@piiqtechnologies/svg-icons';
import { styled } from '@mui/material/styles';

const PeekChip = styled((props) => (React.createElement(Chip, Object.assign({ deleteIcon: React.createElement(X, { height: 14, width: 14 }) }, props))))(({ theme }) => ({
    height: "auto",
    borderRadius: theme.spacing(3),
    "& .MuiChip-label": Object.assign(Object.assign({}, theme.typography.body1), { lineHeight: theme.spacing(1.5), padding: `${theme.spacing(0.45)} ${theme.spacing(1)}` }),
    "& .MuiChip-icon": {
        width: theme.spacing(1.6),
    },
    "&.MuiChip-filledDefault": {
        backgroundColor: theme.palette.grey[50],
    },
    "& .MuiChip-labelMedium": {
        padding: `${theme.spacing(0.6)} ${theme.spacing(1)}`,
    },
}));

export { PeekChip, PeekChip as default };
